module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/1a88d4b4c95e4f7675f834e35bd09333.png";